module.exports = __webpack_public_path__ + "static/maple-bg-ea5b03ad6fe287587632ebf2e2b52a1b.jpg";